import styled from '@emotion/styled';
import {
  TextDisplayAlt,
  TextParagraph,
  token,
} from '@ferreri/prever-component-lib';

import { FEEDBACKS } from './feedbacks';
import { FeedbackCarousel } from './FeedbackCarousel';

export const FeedbackSection = () => {
  const topFeedbacks = FEEDBACKS.slice(0, Math.ceil(FEEDBACKS.length / 2));
  const bottomFeedbacks = FEEDBACKS.slice(Math.ceil(FEEDBACKS.length / 2));

  return (
    <FeedbackSectionContainer id="depoimentos">
      <FeedbackContent>
        <FeedbackHeader>
          <FeedbackTitle>
            Veja o que as famílias associadas dizem sobre o Angeplus
          </FeedbackTitle>
        </FeedbackHeader>
        <CarouselsContainer>
          <FeedbackCarousel feedbacks={topFeedbacks} direction="left" />
          <FeedbackCarousel feedbacks={bottomFeedbacks} direction="right" />
        </CarouselsContainer>
        <Disclaimer>
          Estes são relatos reais de nossos associados, mas a experiência e os
          benefícios podem variar de acordo com cada caso e plano contratado.
        </Disclaimer>
      </FeedbackContent>
    </FeedbackSectionContainer>
  );
};

const FeedbackSectionContainer = styled.section`
  background-color: ${token.colors.neutralXLight};
  padding: ${token.spacing.spacingXxLarge} 0;
  width: 100%;
`;

const FeedbackContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 ${token.spacing.spacingMedium};
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const FeedbackHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-bottom: ${token.spacing.spacingXLarge};
  max-width: 800px;
`;

const FeedbackTitle = styled(TextDisplayAlt)`
  color: ${token.colors.solidAngeplusForeground} !important;
  font-size: 28px;

  @media (min-width: 768px) {
    font-size: 36px;
  }
`;

const CarouselsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: -12px 0;
`;

const Disclaimer = styled(TextParagraph)`
  color: ${token.colors.neutralXDark} !important;
  font-size: 12px;
  text-align: center;
  max-width: 800px;
  margin-top: ${token.spacing.spacingMedium};

  @media (min-width: 768px) {
    font-size: 14px;
  }
`;
